module.exports = __webpack_public_path__ + "static/img/klid.124f303.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing/klid.jpg
// module id = 944i
// module chunks = 0